/**
 * Chrome shared by the icon-only controls that sit beside a contact row
 * (WhatsAppLink, HQMapDialog).
 *
 * The box is fixed at 44x44 - the minimum tap target in CLAUDE.md and WCAG
 * 2.5.5 - and stays visually bare, so each call site supplies its own chip via
 * a child span. `outline-current` keeps the focus ring on the glyph colour,
 * which is what makes it clear the 3:1 contrast bar on both light and dark
 * surfaces.
 */
export const ICON_BUTTON_CLASS =
  'flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition duration-200 active:scale-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current';
